import React from 'react';
import PropTypes from 'prop-types';

import { branch } from 'baobab-react/higher-order';

import styles from './index.module.css';
import BLOCKS from '@store/blocks';

import comm from '@utils/comm';

import Dropdown from '@components/common/dropdown';

import Button from '@components/common/button';
import ScrollBlock from "@components/common/scroll-block";

import { SET_LOCATION, SET_SUBLOCATION, OPEN_POPUP } from './actions';
import { UPDATE_BALANCE } from '@components/containers/user-info-block/actions';

import Block, {LOCATIONS} from '@components/common/block';

import muniGovt1 from '@images/locations/image 201.jpg';
import waterTower1 from '@images/locations/image 162.jpg';
import btex1 from '@images/locations/image 158.jpg';
import firnFreeze1 from '@images/locations/image 152.jpg';
import kilroys1 from '@images/locations/image 181.jpg';
import pluckers1 from '@images/locations/image 219.jpg';
import selfLume1 from '@images/locations/image 193.jpg';
import fallowHome1 from '@images/locations/image 145.jpg';
import kameKondos1 from '@images/locations/image 139.jpg';
import tillies1 from '@images/locations/image 213.jpg';
import fourHomes1 from '@images/locations/image 223.jpg';
import vinyards1 from '@images/locations/image 187.jpg';
import eolianAcres1 from '@images/locations/image 149.jpg';
import townWell1 from '@images/locations/image 197.jpg';
import wedgingNursery1 from '@images/locations/image 207.jpg';

import firnFreeze2 from '@images/locations/image 133.jpg';
import fallowHome2 from '@images/locations/image 142.jpg';
import btex2 from '@images/locations/image 155.jpg';
import kilroys2 from '@images/locations/image 178.jpg';
import vinyards2 from '@images/locations/image 184.jpg';
import selfLume2 from '@images/locations/image 190.jpg';
import wedgingNursery2 from '@images/locations/image 204.jpg';
import tillies2 from '@images/locations/image 210.jpg';
import pluckers2 from '@images/locations/image 216.jpg';

const imgInnerOuterCorrespondence = {
  muniGovt1,
  waterTower1,
  btex1,
  firnFreeze1,
  kilroys1,
  pluckers1,
  wedgingNursery1,
  selfLume1,
  fallowHome1,
  kameKondos1,
  townWell1,
  tillies1,
  fourHomes1,
  vinyards1,
  eolianAcres1,
  fallowHome2,
  btex2,
  kilroys2,
  vinyards2,
  selfLume2,
  wedgingNursery2,
  tillies2,
  firnFreeze2,
  pluckers2
};



function locValToName(vals) {
  return vals.map(val => ({ title: comm.dataStore.locations[val].displayName }));
}

class ReconPanelsBlock extends React.Component {

  constructor(props) {
    super(props);

    this.state = { extraLocations: [] };
    this.extraLocValues = [];
    this.locations = [];
    const commLoc = ["btex", "firnFreeze", "kilroys", "pluckers", "vinyards", "selfLume", "tillies", "wedgingNursery"];
    const govtLoc = ["muniGovt", "townWell", "waterTower"];
    const resLoc = ["eolianAcres", "fallowHome", "fourHomes", "kameKondos"];
    const commTitle = "- Commercial:";
    const govtTitle = "- Government:";
    const resTitle = "- Residential:";

    this.locations.push({title: commTitle, inactive: true});
    this.locations = this.locations.concat(locValToName(commLoc));
    this.locations.push({title: govtTitle, inactive: true});
    this.locations = this.locations.concat(locValToName(govtLoc));
    this.locations.push({title: resTitle, inactive: true});
    this.locations = this.locations.concat(locValToName(resLoc));

    this.locCodes = [commTitle].concat(commLoc).concat([govtTitle]).concat(govtLoc).concat([resTitle]).concat(resLoc);

    this.onLocationChange = this.onLocationChange.bind(this);
    this.onSublocationChange = this.onSublocationChange.bind(this);
    this.visit = this.visit.bind(this);
  }

  visit() {

    let locationName = this.props.currentLocation;

    let location = comm.dataStore.locations[locationName];
    if(location.sublocations) {
      let sublocation = this.props.currentSublocation;
      if(!sublocation) {
        this.props.dispatch(OPEN_POPUP, 'error_no_sublocation');
        return false;
      }

      comm.dataStore.saveVisit(sublocation, 25);
      this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
      if (!comm.dataStore.locations[sublocation].person) {
        this.props.dispatch(OPEN_POPUP, '_nobody_' + sublocation);
        return false;
      }
      this.props.dispatch(OPEN_POPUP, 'interview_' + sublocation);
    } else {
      comm.dataStore.saveVisit(locationName, 25);
      this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
      //navObj.updateBalance();
      if(location.person) {
        this.props.dispatch(OPEN_POPUP, 'interview_' + locationName);
      } else {
        this.props.dispatch(OPEN_POPUP, '_nobody_' + locationName);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentLocation !== this.props.currentLocation) {
      let sublocations = comm.dataStore.locations[this.props.currentLocation].sublocations;

      let extraLocations;
      if (sublocations) {
        extraLocations = [{title:"Choose...", inactive: true}];
        this.extraLocValues = [""];
        for (let i = 0; i < sublocations.length; i++) {
          extraLocations.push({ title: sublocations[i].displayName });
          this.extraLocValues.push(sublocations[i].internalName);
        }
        this.setState({ extraLocations }, () => {
          this.props.dispatch(SET_SUBLOCATION, this.extraLocValues[0]);
        });
      } else {
        extraLocations = [];
        this.extraLocValues = [];
        this.setState({ extraLocations }, () => {
          this.props.dispatch(SET_SUBLOCATION, '');
        });
      }
    }
  }

  onLocationChange(loc) {
    this.props.dispatch(SET_LOCATION, this.locCodes[loc]);
  }

  onSublocationChange(loc) {
    if (!this.extraLocValues || !this.extraLocValues.length) return false;

    this.props.dispatch(SET_SUBLOCATION, this.extraLocValues[loc]);
  }

  render() {
    let props = this.props;

    let currentLocation = props.currentLocation;

    let location = comm.dataStore.locations[currentLocation];
    let descr = location.description;

    let img1 = currentLocation + "1";
    let img2 = currentLocation + "2";

    const extraLocKey = this.state.extraLocations.reduce((acc, cur) => acc + cur, '');

    return (<React.Fragment>

      <Block
        header='Choose a location:'
        location={LOCATIONS.TOP}
        className={`${styles.block} ${styles.initBlock}`}>
        <Dropdown
          onChange={this.onLocationChange}
          className={styles.dropdown}
          value={this.locCodes.indexOf(props.currentLocation)}
          config={{ header: '', items: this.locations }}/>
        <div className={styles.staticBlock}>
          Pick a location by clicking on it on the map or by selecting it from the menu above. Visiting a location costs $25. When interviewing someone, questions cost $1 each.
        </div>
      </Block>
      <Block header=''
        location={LOCATIONS.TOP}
        className={`${styles.block} ${styles.furtherBlock}`}>
        <div className={styles.optionalBlock}>{this.state.extraLocations.length > 0 &&
          <React.Fragment><span>{currentLocation === "muniGovt" ? 'Government offices:' : 'Properties at this location:'}</span>
            {this.extraLocValues.indexOf(props.currentSublocation) > -1 && <Dropdown
              key={extraLocKey}
              onChange={this.onSublocationChange}
              className={styles.dropdownSublocation}
              value={this.extraLocValues.indexOf(props.currentSublocation)}
              config={{ header: '', items: this.state.extraLocations }}/>}</React.Fragment>}</div>
        <ScrollBlock className={styles.scrollBlock}>{descr}</ScrollBlock>
        <div className={styles.simpleBlock}><div className={styles.smallTip}>You may visit the site to interview anyone present</div><Button className={styles.button} onClick={this.visit}>Visit</Button></div>
        <div className={styles.imgBlock}>
          <div className={styles.firstPic}>{img1 in imgInnerOuterCorrespondence && <img alt='An image of the location' src={imgInnerOuterCorrespondence[img1]} />}</div>
          <div className={styles.secondPic}>{img2 in imgInnerOuterCorrespondence && <img alt='An image of the location' src={imgInnerOuterCorrespondence[img2]} />}</div>
        </div>
      </Block>

    </React.Fragment>);
  }
}

ReconPanelsBlock.propTypes = {
  currentLocation: PropTypes.string.isRequired,
  currentSublocation: PropTypes.string.isRequired
};

export default branch({
  currentLocation: BLOCKS.HISTORY_PANELS.CURRENT_LOCATION,
  currentSublocation: BLOCKS.HISTORY_PANELS.CURRENT_SUBLOCATION
}, ReconPanelsBlock);